

//=========================================================
// 路由包装
//=========================================================

import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isLogin, userInfo } from "../NetworkFactory";
import { T } from "../views/language/LanduagesManager";

const WrapperRouter = (props) => {

    const navigate = useNavigate()
    const location = useLocation()
    const data = location.state || {}
    const needLogin = props.login !== undefined

    const navpush = (path = '/', replace = false, data = {}) => {
        navigate(path, {
            replace : replace,
            state : data,
            viewTransition : true
        })
    }

    const loginpush = (path = '/', replace = false, data = {}) => {
        if(isLogin()) {
            navpush(path, replace, data)
        } else {
            navpush('/login')
        }
    }

    const goback = ()=>{
        if(window.history.length <= 2) {
            navpush('/', true)
        } else {
            navigate(-1)
        }
    }

    const gohome = () => {
        navpush('/', true)
    }

    const myInfo = () => {
        return userInfo()
    };

    useEffect(() => {
        // # 置顶
        window.scrollTo({top : '0'})

        if(needLogin) {
            if(!isLogin()) {
                gohome()
            }
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if(needLogin) {
        if(!isLogin()) {
            return <></>
        }
    };
    
    return (<>
        {
            React.Children.map(props.children, child =>
                React.cloneElement(child, 
                    { 
                        navpush : navpush,
                        loginpush : loginpush, 
                        goback : goback,
                        gohome : gohome,
                        data : data,
                        user: myInfo(),
                        t : T
                    })
            )
        }
    </>)
}

export default React.memo(WrapperRouter);